<template>
	<Row class="page-container-row always-show-scrollbar">
		<Col :span="24">
			<PageContainer :narrow="showOnMap">
				<RoversConnectionStats v-show="!showOnMap" />
				<ActiveRoverSessionsPage v-if="showCasterEventsStats" :onSessionIdClick="handleSessionIdClick" />
				<div v-if="showCasterEventsStats && !showOnMap" ref="casterEventsStatsSectionRef">
					<CasterEventsStatsPage ref="casterEventsStatsRef" />
				</div>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { computed, ref, nextTick } from 'vue';
import { Row, Col } from 'ant-design-vue';

import { useRoversHistoryStore } from '@/stores/roversHistoryStore';
import { useLicenseStore } from '@/stores/licenseStore';

import PageContainer from '@/components/common/PageContainer';

import RoversConnectionStats from '@/components/roversHistory/RoversConnectionStats';
import ActiveRoverSessionsPage from '@/components/roversHistory/ActiveRoverSessionsPage';
import CasterEventsStatsPage from '@/components/stats/CasterEventsStatsPage';

export default {
	components: {
		Row, Col,
		PageContainer,
		RoversConnectionStats,
		ActiveRoverSessionsPage,
		CasterEventsStatsPage,
	},
	setup() {
		const roversHistoryStore = useRoversHistoryStore();
		const showOnMap = computed(() => roversHistoryStore.showOnMap);
		const licenseStore = useLicenseStore();
		const showCasterEventsStats = computed(() => licenseStore.featureFlagDashboard);
		const casterEventsStatsRef = ref();
		const casterEventsStatsSectionRef = ref();
		const handleSessionIdClick = sessionId => {
			if (casterEventsStatsRef.value != null) {
				casterEventsStatsRef.value.setSessionIdFilter(sessionId);
				nextTick(() => {
					const el = casterEventsStatsSectionRef.value;
					if (el != null && typeof el.scrollIntoView === 'function') {
						el.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				});
			}
		};
		return {
			showOnMap,
			showCasterEventsStats,
			casterEventsStatsRef,
			casterEventsStatsSectionRef,
			handleSessionIdClick,
		};
	},
}
</script>
